angular.module('app.myProfile.subscriptionHistory.subscriptionHistoryService', [])
  .factory('subscriptionHistoryService', [
    '$http',
    function ($http) {
      "use strict";

      let service = {
        list: null,
        error: null,
        retrieve: function () {
          return $http.get(window.location.api('my_account/data/subscriptions'))
            .then(
              /**
               * @param {HttpResponse} response
               */
              function (response) {
                /**
                 * @type {{subscriptions: Subscription[], error: *}}
                 */
                let data = response.data;

                service.error = null;
                if (data.error) {
                  service.error = data.error;
                }
                else if (data.subscriptions) {
                  service.list = data.subscriptions;
                }
                else {
                  service.error = 'Failed to retrieve subscription history.';
                }
              }
            );
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/myProfile/subscriptionHistory/subscriptionHistoryService.js